export default "__VITE_ASSET__B$uLGXM6__"